import { criarPermissoesPadrao, buscarPermissoes } from "../services/API";

// Cache local para evitar chamadas desnecessárias
let permissoesInicializadas = false;

/**
 * Função para inicializar permissões padrão no backend
 * Esta função deve ser chamada uma vez para criar as permissões básicas
 */
export const inicializarPermissoesPadrao = async (): Promise<void> => {
  try {
    // Verifica se já foi inicializado para evitar chamadas desnecessárias
    if (permissoesInicializadas) {
      return;
    }

    // Primeiro, tenta buscar as permissões existentes
    const permissoesExistentes = await buscarPermissoes();

    if (permissoesExistentes.length === 0) {
      await criarPermissoesPadrao();
    }

    // Marca como inicializado
    permissoesInicializadas = true;
  } catch (error) {
    console.error("Erro ao inicializar permissões padrão:", error);
    throw new Error("Falha ao inicializar permissões padrão no sistema.");
  }
};

/**
 * Função para verificar se o sistema de permissões está configurado
 */
export const verificarSistemaPermissoes = async (): Promise<boolean> => {
  try {
    const permissoes = await buscarPermissoes();
    return permissoes.length > 0;
  } catch (error) {
    console.error("Erro ao verificar sistema de permissões:", error);
    return false;
  }
};

/**
 * Função para resetar o cache de permissões (útil para logout)
 */
export const resetarCachePermissoes = (): void => {
  permissoesInicializadas = false;
};
